import React from "react"

// import { RellaxWrapper as Rellax } from "react-rellax-wrapper"
// import useInstagramImages from "./useInstagramImages"
// import useWindowWidth from "@hooks/window-width"

// import Twitter from "@assets/svg/twitter-red.inline.svg"
// import Facebook from "@assets/svg/facebook-red.inline.svg"
// import Instagram from "@assets/svg/instagram-red.inline.svg"
// import pint from "@assets/images/euro-header/pint.png"

import * as s from "./InstagramFeed.module.scss"

const InstagramFeed = ({ data }) => {
  // const { heading, blurb, backgroundImage } = data
  // const images = useInstagramImages()
  // const windowWidth = useWindowWidth()

  // const numImages = windowWidth < 1024 ? 4 : 12
  // const displayImages = images
  //   ?.filter(image => image.mediaType === "IMAGE")
  //   ?.filter((_, index) => index < numImages)

  // // If we don't have images to display, get an array of the right length
  // // to temporarily map over and create placeholders
  // const noDisplayImages =
  //   !images || displayImages.length === 0 ? [...new Array(numImages)] : null

  // const socials = [
  //   {
  //     key: "Twitter",
  //     icon: Twitter,
  //     link: "https://twitter.com/tennentslager",
  //     display: "TennentsLager",
  //   },
  //   {
  //     key: "Facebook",
  //     icon: Facebook,
  //     link: "https://facebook.com/tennentslager",
  //     display: "TennentsLager",
  //   },
  //   {
  //     key: "Instagram",
  //     icon: Instagram,
  //     link: "https://instagram.com/tennentslager",
  //     display: "tennentslager",
  //   },
  // ]

  return (
    <div
      className={`${s.instagramFeed}`}
      // style={{ backgroundImage: `url(${backgroundImage.sourceUrl})` }}
      style={{
        padding: "40px",
        textAlign: "center",
        backgroundColor: "#f8f8f8",
        border: "1px solid #ddd",
        margin: "20px 0"
      }}
    >
      <h2 style={{ fontSize: "24px", color: "#333", marginBottom: "10px" }}>
        Instagram Feed No Longer Available
      </h2>
      <p style={{ fontSize: "16px", color: "#555" }}>
        This component is no longer available. Please remove it from the page.
      </p>
    </div>
  )
}

export default InstagramFeed
